export default {
      id: "icon-sign-out-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-sign-out",
      toString: function () {
        return this.url;
      }
    }